import React from "react";
import { Layout } from "antd";
import BookingPage from "pages/BookingPage";
import { Navigate, Route, Routes } from "react-router-dom";
import PaymentPage from "pages/PaymentPage";
import ConfirmationPage from "pages/ConfirmationPage";
import styled from "@emotion/styled";
import useRequest from "hooks/useRequest";
import Services, { getToken } from "services/Services";
import { Box, css, Flex, Image } from "theme-ui";
import { useGlobalContext, withGlobalContext } from "state/GlobalContext";
import useMount from "hooks/useMount";

const App: React.FC = () => {
  const [{state, dispatch}] = useGlobalContext();

  const [request] = useRequest(async () => {
    const result = await Services.Park.find({ filter: { code: 'MRRV' }})
    const park = result[0];
    dispatch({ type: 'SELECT_PARK', payload: { park: park }});
  });

  useMount(request.execute);

  if (request.status !== 'success') return null;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header>
        <Flex sx={{ maxWidth: 'container', mx: 'auto', height: '100%', justifyContent: ['center', 'center', 'left'] }}>
          <Image src={state.selectedPark?.brandingSetting?.logoUrl} my={2} />
        </Flex>
      </Header>
      <Content>
        <Routes>
          <Route path="/" element={<Navigate to="checkout" />} />
          <Route path="/checkout" element={<BookingPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
        </Routes>
      </Content>
      <Footer>
        <Flex sx={{alignItems: 'center', maxWidth: 960, height: [80, 160]}} mx="auto">
          <Box mx={3} sx={{textAlign: ['center', 'center', 'left'], width: '100%' }}>
            © {(new Date()).getFullYear()} {state.selectedPark?.name}  •  Privacy  •  Terms  •  Sitemap
          </Box>
        </Flex>
      </Footer>
    </Layout>
  );
};

const HeaderBase = styled(Layout.Header)`
  position: fixed;
  width: 100%;
  z-index: 999;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
`;

const Footer = styled(Layout.Footer)`
  padding: 0;
`;

const Header = styled(HeaderBase)(css({
  height: [64, 84],
}));

const Content = styled(Layout.Content)(css({
  paddingTop: [64, 84],
}));

const withLoader = (Component: React.FC) => (props: any) => {
  const [request] = useRequest(async () => await getToken());
  useMount(request.execute);

  if (request.status !== 'success') return null;
  
  return (
   <>
     <Component {...props} />
   </>
  );
}

export default withGlobalContext(withLoader(App));
